import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-manage-managenta',
  templateUrl: './managentacomorbidity.component.html',
  styleUrls: ['./managentacomorbidity.component.scss']
})
export class managentacomorbidityComponent implements OnInit { 
  
  formDialog: FormGroup;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
  };  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  currentUser: any;
  organizationId: string;
  databaseId: string;
  responseHolder: any;  
  OfficeIDList: any=[];
  myOfficeID: any;
  spinner:boolean=false;
 
  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService, private toastr: ToastrService,
     private statusConst: StatusConstant, private reusableClass: ReusableClasses, private dialog: MatDialog,
     private settingsService: SettingService, private encryptionAlgo: EncryptionService,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID);
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }

  ngOnInit(): void {
    
    this.GetNTAJsonFromBlob();
  }

   
   ntaJsonData:any="";
   // For Update OCR Category Status
   UpdateNTAJsonInBlob() {
    this.loaderService.show();
    this.settingsService.UpdateNTAJsonInBlob({NtaJsonData:this.ntaJsonData}).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder) {          
          this.toastr.success('NTA updated successfully.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
        }else{
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
   }
 // Adjust textarea height dynamically
 adjustHeight(textarea: HTMLTextAreaElement) {
  textarea.style.height = 'auto'; // Reset height
  textarea.style.height = textarea.scrollHeight + 'px'; // Set to scroll height
}
   GetNTAJsonFromBlob() {
    this.loaderService.show();
    this.settingsService.GetNTAJsonFromBlob().subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder) {          
          this.ntaJsonData=this.responseHolder
          setTimeout(() => {
            this.adjustHeight(document.getElementById('ntatxtarea') as HTMLTextAreaElement);
        }, 200);
          this.loaderService.hide();
        }else{
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
   }

     
}
